import React from 'react';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SALON_PUBLIC_LAYOUT_REGISTRY } from '../../../theme/salonPublicLayout';
import SalonLayoutOptionGroup from './SalonLayoutOptionGroup';


const firstError = (error) => (Array.isArray(error) ? error[0] : error || '');

const SalonHeaderLayoutControls = ({
  value,
  errors = {},
  onChange,
  disabled = false,
  registerFieldRef = () => {},
}) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2.5}>
      {Object.entries(SALON_PUBLIC_LAYOUT_REGISTRY.header).map(([axis, values]) => (
        <SalonLayoutOptionGroup
          key={axis}
          legend={t(`salon_theme.layout.header.${axis}.legend`)}
          name={`salon-layout-header-${axis}`}
          value={value?.[axis]}
          options={values.map((optionValue) => ({
            value: optionValue,
            label: t(`salon_theme.layout.header.${axis}.options.${optionValue}`),
          }))}
          onChange={(nextValue) => onChange(axis, nextValue)}
          disabled={disabled}
          error={firstError(errors?.[axis])}
          focusRef={(element) => registerFieldRef(axis, element)}
          selectedLabel={t('salon_theme.layout.selected')}
        />
      ))}
    </Stack>
  );
};

export default SalonHeaderLayoutControls;
